import ssctBnbCakeLpFarmingPoolTestFee30 from "../abis/development/ssctBnb/pools/testFee30";
import ssctBnbCakeLpFarmingPoolTestFee0 from "../abis/development/ssctBnb/pools/testFee0";

const host = "https://bscscan.com/address";
const swapHost = "https://pancakeswap.finance/add";
const pairHost = "https://pancakeswap.info/pool";

export default [
  {
    title: "Test Fee 30",
    temperature: 30,
    type: "bnb",
    contractAddress: "0x9dd75545386fd7bb574948a46b2f94c2ce67afdb",
    minApr: 159,
    abi: ssctBnbCakeLpFarmingPoolTestFee30.abi,
    url: `${host}/0x9dd75545386fd7bb574948a46b2f94c2ce67afdb`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
  {
    title: "Test Fee 0",
    temperature: 0,
    type: "bnb",
    contractAddress: "0xc25b81ce7d0ff8fd44ae8c71ba58ee0fce5c0eb0",
    minApr: 159,
    abi: ssctBnbCakeLpFarmingPoolTestFee0.abi,
    url: `${host}/0xc25b81ce7d0ff8fd44ae8c71ba58ee0fce5c0eb0`,
    swapUrl: `${swapHost}/BNB/0x06b889a7a7fa15D8cC7CFf147962C4232cCE7CF0`,
    pairUrl: `${pairHost}/0x555808d7e7b82b9beef6388b65e1d98cf6069f75`,
  },
];
